import PropTypes from "prop-types";
import React from "react";
import SummaryCardBusOps from "components/Shared/TimeLogs/SummaryCardBusOps";
import SummaryCardValuation from "components/Shared/TimeLogs/SummaryCardValuation";

class SummaryCard extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { isBusOpsEmployeeTimeLogs, isAppraiserEmployeeTimeLogs } = this.props;
    return (<>
      {
        isBusOpsEmployeeTimeLogs && <SummaryCardBusOps {...this.props} />
      }
      {
        isAppraiserEmployeeTimeLogs && <SummaryCardValuation {...this.props} />
      }
    </>);
  }
}

SummaryCard.defaultProps = {
  isEmployeeTimeLogsView: false,
  isBusOpsEmployeeTimeLogs: false,
  isAppraiserEmployeeTimeLogs: false
};

SummaryCard.propTypes = {
  data: PropTypes.object.isRequired,
  filterDateCallBack: PropTypes.func.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  payPeriodId: PropTypes.number.isRequired,
  internetUserId: PropTypes.number.isRequired,
  employeeName: PropTypes.string,
  refreshCard: PropTypes.bool,
  magicMinHeight: PropTypes.bool,
  isEmployeeTimeLogsView: PropTypes.bool,
  isAppraiserEmployeeTimeLogs: PropTypes.bool,
  isBusOpsEmployeeTimeLogs: PropTypes.bool
};

export default SummaryCard;